import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Typography, List, ListItem, ListItemText, ListItemIcon, Box, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '../../../../Icon';
import Button from '../../../../Button';
import Utils from '../../../../../utils';
import RepositoryPicker from '../../../../RepositoryPicker';
import { useDocumentDispatch, useDocumentState, insertSpreadsheet } from '../context/documentContext';
import Confirmation from '../../../../../modal/variants/Confirmation';
var useStyles = makeStyles(function (theme) {
  return {
    disabledText: {
      color: theme.palette.text.hint,
      paddingBottom: theme.spacing(2)
    },
    listIcon: {
      marginRight: theme.spacing(1),
      fontSize: 14
    },
    dataButtons: {
      justifyContent: 'flex-start'
    },
    list: {
      margin: theme.spacing(0, -3)
    },
    listItem: {
      height: 34,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(2)
    },
    root: {
      '&:hover': {
        '& $icon': {
          display: 'inline-block'
        }
      }
    },
    icon: {
      fontSize: 14,
      display: 'none'
    }
  };
}, {
  name: 'ECSidebarData'
});

var SidebarData = function SidebarData(_ref) {
  var dataSources = _ref.dataSources,
      selectedItemId = _ref.selectedItemId,
      onSelectItemId = _ref.onSelectItemId,
      workspace = _ref.workspace,
      path = _ref.path,
      onEdit = _ref.onEdit;
  var classes = useStyles();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      filePickerOpen = _useState2[0],
      setFilePickerOpen = _useState2[1];

  var documentDispatch = useDocumentDispatch();
  var documentState = useDocumentState();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      warningDialogOpen = _useState4[0],
      setWarningDialogOpen = _useState4[1];

  var handleFilePickerChanged =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(files) {
      var id;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFilePickerOpen(false);
              id = (parseInt(documentState.content.job.lastId) + 1).toString();
              insertSpreadsheet(documentDispatch, {
                basePath: Utils.path.getFolderPath(path),
                workspace: files[0].workspace,
                path: files[0].path,
                id: id
              }).then(function () {
                onSelectItemId(id);
              }).catch(function () {
                return setWarningDialogOpen(true);
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFilePickerChanged(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    height: "100%"
  }, React.createElement(Box, {
    flex: "0 0 36%"
  }, React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "Data"), React.createElement(Typography, {
    className: classes.disabledText
  }, "Click to add a new data source"), React.createElement(Button, {
    icon: "table",
    color: "inherit",
    variant: "text",
    className: classes.dataButtons,
    onClick: function onClick() {
      setFilePickerOpen(true);
    }
  }, "Spreadsheet")), React.createElement("div", null, React.createElement(Typography, {
    variant: "h6"
  }, "Sources"), React.createElement(List, {
    className: classes.list
  }, dataSources.filter(function (dataSource) {
    return dataSource.elementName === 'csvUrl';
  }).map(function (file) {
    return React.createElement(ListItem, {
      key: file.id,
      button: true,
      dense: true,
      className: classes.listItem + ' ' + classes.root,
      selected: file.id === selectedItemId,
      onClick: function onClick() {
        return onSelectItemId(file.id);
      }
    }, React.createElement(ListItemIcon, null, React.createElement(Icon, {
      type: "table",
      className: classes.listIcon
    })), React.createElement(ListItemText, {
      disableTypography: true
    }, React.createElement(Typography, {
      noWrap: true
    }, file.name ? file.name : Utils.path.getFileCaption(file.src))), React.createElement(Icon, {
      type: "style",
      className: classes.icon,
      onClick: onEdit,
      buttonSize: "small"
    }));
  }))), filePickerOpen && React.createElement(RepositoryPicker, {
    lockWorkspace: true,
    workspace: workspace,
    path: path,
    fileExtensions: ['csv'],
    maxUploadSize: 1024 * 1024 * 50,
    onChange: handleFilePickerChanged,
    onClose: function onClose() {
      setFilePickerOpen(false);
    }
  }), warningDialogOpen && React.createElement(Confirmation, {
    title: "Invalid File",
    message: "Please select a CSV file with headers.",
    confirmLabel: "Close",
    hideCancel: true,
    onConfirm: function onConfirm() {
      return setWarningDialogOpen(false);
    },
    onClose: function onClose() {
      return setWarningDialogOpen(false);
    }
  }));
};

export default SidebarData;